import React, { useRef } from 'react';
import { ILinkProps } from '../../../interfaces/interfaces';
import keyboardTriggerBasic from '../../../utils/keyboard-trigger';

function TileWrapper(
  props: {
    className: string;
    children: JSX.Element | JSX.Element[];
    clickable: boolean;
  } & ILinkProps,
): JSX.Element {
  const { className, children, clickable, locked } = props;
  const linkRef = useRef<HTMLDivElement>(null);

  const onClickTile = (e: React.KeyboardEvent<HTMLDivElement> | React.MouseEvent<HTMLDivElement>) => {
    const isLink = (e.target as HTMLDivElement).className === linkRef.current?.querySelector('a')?.className;
    const isInLink =
      (e.target as HTMLDivElement).parentElement?.className === linkRef.current?.querySelector('a')?.className;
    // skip click-propergation if click was on link directly
    if (isLink || isInLink) {
      return;
    }
    linkRef?.current?.querySelector('a')?.click();
  };

  return (
    <div
      className={`tile-wrapper ${className || ''} ${clickable && !locked ? 'tile-clickable' : ''} ${
        locked ? 'locked' : ''
      }`}
      ref={linkRef}
      role="button"
      // tabIndex={0}
      onClick={clickable ? (e) => onClickTile(e) : undefined}
      onKeyPress={(e) => {
        keyboardTriggerBasic(
          e,
          () => {
            if (clickable) {
              onClickTile(e);
            }
          },
          true,
        );
      }}
    >
      {children}
    </div>
  );
}
export default TileWrapper;
